{
  "version": 1,
  "asset_id": "6b29823c-952a-4f87-918a-19d9c5fe6261",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/6b29823c-952a-4f87-918a-19d9c5fe6261/g22.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/6b29823c-952a-4f87-918a-19d9c5fe6261/g22.jpg",
  "original_filename": "g22.jpg",
  "size": 139370,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T23:00:11Z"
}
